<!-- start page title -->
<div class="row">
  <div class="col-12">
    <div class="page-title-box d-lg-flex align-items-center justify-content-between">
      <h4 class="mb-0">{{title}}</h4>

      <div class="page-title-right">
        <ol class="breadcrumb m-0">
          @for (item of breadcrumbItems; track $index) {
            <li class="breadcrumb-item" [ngClass]="{'active': item.active === true}">
              @if (item.link && !item.active) {
                <a [routerLink]="item.link">{{ item.label }}</a>
              } @else {
                {{ item.label }}
              }
            </li>
          }
        </ol>
      </div>
    </div>
  </div>
</div>
<!-- end page title -->
